import React, { useState, useEffect } from 'react';
import Lottie from "lottie-react";
import Navbar from '../Navbar/Navbar';
import './Dashboard.css';
import CargaGasModal from './FormularioCargaGas';
import FormularioNuevaBotella from './FormularioNuevaBotella';
import AnimationData from '../Loading.json'
import FormularioCambioAlmacen from './FormularioCambioAlmacen';


// te voy a cambair los alert por toastify
// toastify es una libreria para mostrar mensajes de alerta
// con esto nos evitamos que el usuario tenga que hacer click en el alert para cerrarlo
// se usa de la siguiente manera:
// toast.success('Mensaje de éxito');
// toast.error('Mensaje de error');
// toast.info('Mensaje de información');
// toast.warn('Mensaje de advertencia');
// toast.dark('Mensaje de advertencia');
// toast.loading('Cargando...');
// el tiempo de duracion esta definido en el App.js es algo como esto:
// <ToastContainer position="top-right" autoClose={3000} />

import { toast } from 'react-toastify';
import logger from '../../utils/logger';


const Dashboard = ({ onNavigate, onLogout, user }) => {
  const [activeTab, setActiveTab] = useState('fichajes');
  const [activeButton, setActiveButton] = useState(null);
  const [observaciones, setObservaciones] = useState('');
  const [botonesHabilitados, setBotonesHabilitados] = useState([]);
  const [tipoSolicitud, setTipoSolicitud] = useState('Vacaciones');
  const [fechaInicio, setFechaInicio] = useState('');
  const [fechaFin, setFechaFin] = useState('');
  const [motivo, setMotivo] = useState('');
  const [solicitudes, setSolicitudes] = useState([]);
  const [botellasGas, setBotellasGas] = useState([]);
  const [filaGasExpandida, setFilaGasExpandida] = useState(null);
  const [logGas, setLogGas] = useState({});
  const [mostrarModalCarga, setMostrarModalCarga] = useState(false);
  const [botellaSeleccionada, setBotellaSeleccionada] = useState(null);
  const [mostrarFormularioNuevaBotella, setMostrarFormularioNuevaBotella] = useState(false);
  const [mostrarCambioAlmacen, setMostrarCambioAlmacen] = useState(false);


  //hay unas variables de entorno que son el archivo .env y el .env.production
  //en el archivo .env.production se encuentran las variables de entorno para producción
  //en el archivo .env se encuentran las variables de entorno para desarrollo
  //esto setea la ruta del servidor dependiendo de si estamos en producción o desarrollo
  const API_URL = process.env.REACT_APP_API_URL || '';

  const [loading, setLoading] = useState(false);

  const botonesFichaje = [
    'Entrada',
    'Salida',
    'Pausa Inicio',
    'Pausa Fin',
    'Comida Inicio',
    'Comida Fin',
  ];

  // 🔧 Configurar usuario en logger cuando carga el Dashboard - OPTIMIZADO
  const [userLogged, setUserLogged] = useState(false);
  useEffect(() => {
    if (user?.usuario && !userLogged) {
      logger.setUser(user.usuario);
      logger.info('Dashboard cargado', {
        tipo: 'DASHBOARD_LOAD',
        datos: { usuario: user.usuario, typeUser: user.typeUser }
      });
      setUserLogged(true); // 👈 NUEVO: Evitar logs repetidos
    }
  }, [user?.usuario, userLogged]); // 👈 NUEVO: Solo depende del usuario ID

  // 🚨 NUEVO: Throttling para último fichaje
  const [lastFichajeCheck, setLastFichajeCheck] = useState(0);

  const actualizarBotonesPorUltimoFichaje = async () => {
    setLoading(true);
    try {
      // 🔇 NUEVO: Solo logear cada 30 segundos para evitar spam
      const now = Date.now();
      if (now - lastFichajeCheck > 30000) {
        logger.debug('Consultando último fichaje', { tipo: 'ULTIMO_FICHAJE_REQUEST' });
        setLastFichajeCheck(now);
      }

      // escribo la ruta asi porque en el archivo .env tengo la variable REACT_APP_API_URL que es la url del servidor en desarrollo
      // en producción la url es diferente, por eso uso {API_URL} para que se adapte a la url del servidor
      const res = await logger.fetchWithLogging(`${API_URL}/api/ultimo-fichaje?usuario=${user?.usuario}`);
      const data = await res.json();
      const ultimo = data.tipo_fichaje;

      // 🔇 NUEVO: Solo logear éxito si se logeó la request
      if (now - lastFichajeCheck < 1000) { // Si acabamos de logear la request
        logger.info('Último fichaje obtenido', {
          tipo: 'ULTIMO_FICHAJE_SUCCESS',
          datos: { tipo_fichaje: ultimo }
        });
      }

      if (!ultimo || ['salida'].includes(ultimo)) {
        setBotonesHabilitados(['Entrada']);
      } else if (['entrada', 'pausa_fin', 'comida_fin'].includes(ultimo)) {
        setBotonesHabilitados(['Pausa Inicio', 'Comida Inicio', 'Salida']);
      } else if (ultimo === 'pausa_inicio') {
        setBotonesHabilitados(['Pausa Fin']);
      } else if (ultimo === 'comida_inicio') {
        setBotonesHabilitados(['Comida Fin']);
      } else {
        setBotonesHabilitados(['Entrada']);
      }
    } catch (err) {
      // 🔇 NUEVO: Solo logear errores cada 60 segundos para evitar spam
      const now = Date.now();
      if (now - lastFichajeCheck > 60000) {
        logger.error('Error al obtener último fichaje', {
          tipo: 'ULTIMO_FICHAJE_ERROR',
          datos: { error: err.message }
        });
        setLastFichajeCheck(now);
      }

      console.error('Error al obtener último fichaje:', err);
      setBotonesHabilitados(['Entrada']);
    } finally {
      setLoading(false);
    }
  };

  const cargarSolicitudes = async () => {
    setLoading(true)
    try {
      const res = await fetch(`${API_URL}/api/mis-solicitudes?usuario=${user?.usuario}`);
      const data = await res.json();
      if (data.success) setSolicitudes(data.data);
    } catch (err) {
      console.error('Error cargando solicitudes:', err);
    } finally {
      setLoading(false)
    }
  };

  const cargarBotellasGas = async () => {
    setLoading(true)
    try {
      const res = await fetch(`${API_URL}/api/gas?usuario=${user?.usuario}`);
      const data = await res.json();
      if (data.success) setBotellasGas(data.data);
    } catch (err) {
      console.error('Error cargando botellas de gas:', err);
    } finally {
      setLoading(false)
    }
  };

  const cargarLogGas = async (idBotella) => {
    setLoading(true)
    try {
      const res = await fetch(`${API_URL}/api/gas-log?idBotella=${idBotella}`);
      const data = await res.json();
      if (data.success) {
        setLogGas(prev => ({ ...prev, [idBotella]: data.data }));
      }
    } catch (err) {
      console.error('Error cargando log de gas:', err);
    } finally {
      setLoading(false)
    }
  };

  // 🚨 NUEVO: Control para evitar ejecutar múltiples veces el mismo usuario
  const [dataLoaded, setDataLoaded] = useState(false);
  const [currentUserId, setCurrentUserId] = useState(null);

  useEffect(() => {
    if (user?.usuario && user.usuario !== currentUserId) {
      console.log('🔄 Cargando datos para usuario:', user.usuario);
      setCurrentUserId(user.usuario);
      setDataLoaded(false);

      // 📝 NUEVO: Solo hacer log una vez por usuario
      logger.info('Cargando datos del dashboard', {
        tipo: 'DASHBOARD_DATA_LOAD',
        datos: { usuario: user.usuario, typeUser: user.typeUser }
      });

      actualizarBotonesPorUltimoFichaje();
      cargarSolicitudes();
      if ([100, 485].includes(user?.typeUser)) cargarBotellasGas();

      setDataLoaded(true);
    }
  }, [user?.usuario, user?.typeUser]); // 👈 NUEVO: Solo depende de campos específicos

  const handleClickCarga = (botella) => {
    setBotellaSeleccionada(botella);
    setMostrarModalCarga(true);
  };

  const handleCerrarModal = (recargar = false) => {
    setMostrarModalCarga(false);
    setBotellaSeleccionada(null);
    if (recargar) {
      cargarBotellasGas(); // 👈 Esto recarga la lista
    }
  };

  const handleClick = async (label) => {
    setActiveButton(label);
    setLoading(true);

    // 📝 Log inicio de fichaje
    logger.info(`Iniciando fichaje ${label}`, {
      tipo: 'FICHAJE_START',
      datos: { tipo_fichaje: label, usuario: user?.usuario }
    });

    try {
      // 🔍 Log intento de obtener GPS
      logger.debug('Solicitando permisos GPS', { tipo: 'GPS_REQUEST' });

      const position = await new Promise((resolve, reject) => {
        navigator.geolocation.getCurrentPosition(
          resolve,
          reject,
          {
            enableHighAccuracy: true,
            timeout: 15000,
            maximumAge: 60000
          }
        );
      });

      const lat = position.coords.latitude;
      const lon = position.coords.longitude;

      // ✅ Log GPS exitoso
      logger.info('GPS obtenido correctamente', {
        tipo: 'GPS_SUCCESS',
        datos: { accuracy: position.coords.accuracy, lat, lon }
      });

      // 🌐 Obtener dirección
      let direccion = 'Dirección no disponible';
      try {
        const response = await logger.fetchWithLogging(`https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lon}`);
        const data = await response.json();
        direccion = data.display_name || 'Dirección no disponible';

        logger.debug('Dirección obtenida', {
          tipo: 'ADDRESS_SUCCESS',
          datos: { direccion: direccion.substring(0, 100) }
        });
      } catch (addressErr) {
        logger.warn('Error al obtener dirección', {
          tipo: 'ADDRESS_ERROR',
          datos: { error: addressErr.message }
        });
      }

      const now = new Date();
      const usuario = user?.usuario;
      const fecha = now.toISOString().slice(0, 10);
      const hora = now.toTimeString().slice(0, 8);
      const tipo_fichaje = label.toLowerCase().replace(' ', '_');
      const pos_gps = `${lat},${lon}`;
      const gps_url = `https://www.google.com/maps?q=${lat},${lon}`;
      const obs = observaciones;

      // 📤 Log envío de fichaje
      logger.debug('Enviando fichaje al servidor', {
        tipo: 'FICHAJE_SEND',
        datos: { tipo_fichaje, fecha, hora, pos_gps: pos_gps.substring(0, 20) }
      });

      const res = await logger.fetchWithLogging(`${API_URL}/api/fichaje`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ usuario, fecha, tipo_fichaje, pos_gps, gps_url, hora, obs, direccion })
      });

      if (res.ok) {
        const responseData = await res.json();

        // ✅ Log fichaje exitoso
        logger.info(`Fichaje ${label} exitoso`, {
          tipo: 'FICHAJE_SUCCESS',
          datos: { tipo_fichaje, mensaje: responseData.message }
        });

        toast.success(`Fichaje "${label}" registrado`);
        setObservaciones('');
        actualizarBotonesPorUltimoFichaje();
      } else {
        const errorData = await res.json();

        // ❌ Log error del servidor
        logger.error(`Error del servidor en fichaje ${label}`, {
          tipo: 'FICHAJE_SERVER_ERROR',
          datos: {
            tipo_fichaje,
            status: res.status,
            error: errorData.message || 'Error desconocido'
          }
        });

        toast.error('Error al registrar el fichaje');
      }
    } catch (err) {
      // ❌ Log error completo con detalles específicos
      if (err.code === 1) {
        // Error de permisos GPS
        logger.gpsError('Permisos GPS denegados', err);
        toast.error('📍 Permisos de ubicación denegados');
      } else if (err.code === 2) {
        // Error de posición no disponible
        logger.gpsError('Posición GPS no disponible', err);
        toast.error('📍 No se puede obtener la ubicación');
      } else if (err.code === 3) {
        // Timeout
        logger.gpsError('Timeout obteniendo GPS', err);
        toast.error('📍 Tiempo agotado obteniendo ubicación');
      } else {
        // Error general
        logger.fichajeError(user?.usuario, label, err);
        toast.warn('⚠️ No se pudo registrar el fichaje');
      }

      console.error(`Error al fichar "${label}":`, err);
    } finally {
      setLoading(false);
    }
  };

  const enviarSolicitud = async () => {
    if (!fechaInicio || !fechaFin) {
      toast.warn('Por favor completa las fechas');
      return;
    }

    const res = await fetch(`${API_URL}/api/solicitudes`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        usuario: user?.usuario,
        tipo: tipoSolicitud,
        fecha_inicio: fechaInicio,
        fecha_fin: fechaFin,
        motivo: motivo
      })
    });

    if (res.ok) {
      toast.success('Solicitud enviada correctamente');
      setMotivo('');
      setFechaInicio('');
      setFechaFin('');
      setTipoSolicitud('Vacaciones');
      cargarSolicitudes();
    } else {
      toast.error('Error al enviar solicitud');
    }
  };

  return (
    <div className="dashboard-container">
      <Navbar
        active="dashboard"
        onNavigate={onNavigate}
        onLogout={onLogout}
        user={user}
      />

      <main className="admin-main">
        <h2>Dashboard</h2>

        <div className="tabs">
          {['Fichajes', 'Solicitudes', ...(user?.typeUser === 100 || user?.typeUser === 485 ? ['Gas'] : [])].map((tab) => (
            <button
              key={tab}
              className={`tab-btn ${activeTab === tab.toLowerCase() ? 'active' : ''}`}
              onClick={() => setActiveTab(tab.toLowerCase())}
            >
              {tab}
            </button>
          ))}
        </div>

        {activeTab === 'fichajes' && (
          <div className="fichajes-panel">
            <div className="fichaje-grid">
              {botonesFichaje.map((label) => (
                <button
                  key={label}
                  className={`fichaje-btn ${activeButton === label ? 'active' : ''}`}
                  onClick={() => handleClick(label)}
                  disabled={!botonesHabilitados.includes(label)}
                >
                  {label}
                </button>
              ))}
            </div>

            <div className="observaciones">
              <label>Observaciones (máx. 50):</label>
              <input
                type="text"
                value={observaciones}
                onChange={(e) => setObservaciones(e.target.value.slice(0, 50))}
                placeholder="Opcional"
              />
            </div>
          </div>
        )}

        {activeTab === 'solicitudes' && (
          <div className="solicitud-form">
            <h3>📅 Solicitudes</h3>
            <div className="form-group">
              <label>Tipo de solicitud</label>
              <select value={tipoSolicitud} onChange={(e) => setTipoSolicitud(e.target.value)}>
                <option>Vacaciones</option>
                <option>Día personal</option>
                <option>Permiso médico</option>
              </select>
            </div>

            <div className="form-dates">
              <div className="form-group">
                <label>Fecha inicio</label>
                <input type="date" value={fechaInicio} onChange={(e) => setFechaInicio(e.target.value)} />
              </div>
              <div className="form-group">
                <label>Fecha fin</label>
                <input type="date" value={fechaFin} onChange={(e) => setFechaFin(e.target.value)} />
              </div>
            </div>

            <div className="form-group">
              <label>Motivo</label>
              <textarea rows="4" value={motivo} onChange={(e) => setMotivo(e.target.value)} placeholder="Opcional..." />
            </div>

            <button className="btn-enviar" onClick={enviarSolicitud}>Enviar Solicitud</button>

            {solicitudes.length > 0 && (
              <div className="tabla-solicitudes">
                <h4>Solicitudes</h4>
                <table>
                  <thead>
                    <tr>
                      <th>Tipo</th>
                      <th>Fecha solicitud</th>
                      <th>Inicio</th>
                      <th>Fin</th>
                      <th>Motivo</th>
                      <th>Estado</th>
                    </tr>
                  </thead>
                  <tbody>
                    {solicitudes.map((s, i) => (
                      <tr key={i}>
                        <td>{s.tipo}</td>
                        <td>{s.fechasolicitud?.slice(0, 10)}</td>
                        <td>{s.fechainicio.slice(0, 10)}</td>
                        <td>{s.fechafin.slice(0, 10)}</td>
                        <td>{s.motivo}</td>
                        <td>
                          {s.estado === 0 && '🕐 Pendiente'}
                          {s.estado === 1 && '✅ Aprobado'}
                          {s.estado === 2 && '❌ Rechazado'}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        )}

        {activeTab === 'gas' && (
          <div className="fichajes-panel">
            <div className="titulo-gas">
              <h3>🔧 Botellas de Gas en propiedad</h3>
              <button
                className="btn-cargar"
                onClick={() => setMostrarFormularioNuevaBotella(true)}
              >
                ➕ Nueva Botella
              </button>
            </div>
            <table className="fichajes-table">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Tipo de Gas</th>
                  <th>Acción</th>
                  <th>Kg Disponibles</th>
                  <th>Kg Totales</th>
                  <th>Kg Gastados</th>
                  <th>Fecha de Alta</th>
                </tr>
              </thead>
              <tbody>
                {botellasGas.map((g, i) => {
                  const totalKg = g.kgTotal / 100;
                  const gastadoKg = g.kgGastados / 100;
                  const gasDisp = (g.kgTotal - g.kgGastados) / 100;
                  const vacia = gastadoKg >= totalKg;
                  const expandida = filaGasExpandida === g.id;

                  return (
                    <React.Fragment key={i}>
                      <tr
                        className="fila-principal"
                        onClick={() => {
                          setFilaGasExpandida(expandida ? null : g.id);
                          if (!expandida) cargarLogGas(g.id);
                        }}
                      >
                        <td>{g.id}</td>
                        <td>{g.tipoGas}</td>
                        <td>
                          {vacia ? (
                            <span className="botella-vacia">Botella vacía</span>
                          ) : (
                            <button className="btn-cargar" onClick={(e) => { e.stopPropagation(); handleClickCarga(g); }}>Realizar carga</button>
                          )}
                        </td>
                        <td>{gasDisp.toFixed(2)}</td>
                        <td>{totalKg.toFixed(2)}</td>
                        <td>{gastadoKg.toFixed(2)}</td>
                        <td>{g.fechaAlta?.slice(0, 10)}</td>
                      </tr>
                      {expandida && (
                        <tr className="fila-expandida">
                          <td colSpan="7">
                            <div className="detalle-fichaje" style={{ overflow: 'auto', maxHeight: '300px' }}>
                              <button
                                className="btn-cambiar-almacen"
                                style={{ marginBottom: '10px' }}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setBotellaSeleccionada(g);
                                  setMostrarCambioAlmacen(true);
                                }}
                              >
                                Cambiar almacén
                              </button>

                              <table style={{ minWidth: '800px', borderCollapse: 'collapse' }}>
                                <thead>
                                  <tr>
                                    <th>ID</th>
                                    <th>Kg Gastado</th>
                                    <th>Cliente</th>
                                    <th>Fecha</th>
                                    <th>Usuario</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {(logGas[g.id] || []).map((l, j) => (
                                    <tr key={j}>
                                      <td>{l.id}</td>
                                      <td>{(l.kgGastado / 100).toFixed(2)}</td>
                                      <td>{l.cliente}</td>
                                      <td>{l.fecha?.slice(0, 10)}</td>
                                      <td>{l.usuario}</td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </div>
                          </td>
                        </tr>
                      )}
                    </React.Fragment>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}

        {mostrarModalCarga && botellaSeleccionada && (
          <CargaGasModal
            botella={botellaSeleccionada}
            usuario={user}
            user={user}   // 👈 así coincide con el nombre en FormularioCargaGas
            onClose={handleCerrarModal}
            onGuardar={handleCerrarModal}
          />
        )}
        {mostrarFormularioNuevaBotella && (
          <FormularioNuevaBotella
            user={user}
            onClose={() => setMostrarFormularioNuevaBotella(false)}
            onGuardar={() => {
              setMostrarFormularioNuevaBotella(false);
              cargarBotellasGas(); // recargar la lista
            }}
          />
        )}
        {mostrarCambioAlmacen && botellaSeleccionada && (
          <FormularioCambioAlmacen
            botella={botellaSeleccionada}
            apiUrl={API_URL}
            onClose={() => {
              setMostrarCambioAlmacen(false);
              setBotellaSeleccionada(null);
            }}
            onGuardar={() => {
              setMostrarCambioAlmacen(false);
              setBotellaSeleccionada(null);
              cargarBotellasGas();
            }}
          />
        )}


        {loading && <div className="loading-overlay">
          <Lottie
            animationData={AnimationData}
            loop={true}
          />
        </div>
        }
      </main>
    </div>
  );
};

export default Dashboard;